import { toggleHoursOfOperation } from "../util/hours_operation";

export class GetHoursOfOperation {
    static async create() {
        await toggleHoursOfOperation('.contact-info .contact-block .get_in_touch_hrs_operation', '.get_in_touch_hrs_operation .card-item', '.card-item li');
        return new GetHoursOfOperation(); 
    }
}

(async () => {
    if (!(globalThis as any).__GetHoursOfOperationDOMLoader) {
        (globalThis as any).__GetHoursOfOperationDOMLoader = true;
        await GetHoursOfOperation.create();
    }
})();